<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <wiz-hgroup width="100%" height="30px" verticalAlign="center" padding="3px" gap="2">
    <wiz-icon style="cursor: pointer; font-size: 20px"  (click)="exportDatas()" [wizTooltip]="'$.widget.export.excel.$'">upload</wiz-icon>
    <wiz-label width="100%" class="smallTitleLabel" [wizLabel]="'$.excel.import.error.title.$'"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>
  <wiz-label width="100%" [wizLabel]="'$.excel.import.howto.$'" style="padding-left: 15px;"></wiz-label>
  <wiz-hgroup padding="5px" width="100%" height="100%">
    <wiz-ag-grid #agGrid width="100%" height="100%" 
    wizRowSelection="none"
    [columnDefs]="columns"
    [wizDatasource]="mainDS" 
    class="ag-theme-alpine"></wiz-ag-grid>
  </wiz-hgroup>

</wiz-vgroup>
